import ButtonIcon from "components/ButtonIcon/ButtonIcon";
import { Tooltip } from "components/Tooltip/Tooltip";
import { useState } from "react";

import { getCopyMedicalRecordsServiceType } from "../../future-medical-utils";
import type { MedicalHistoryTableProps } from "../medicalRecordUtils";

import CopyMedicalRecordsFromMetadocModal from "./CopyMedicalRecordsFromMetadocModal";
import { useMetadocsWithAiResultsForFile } from "./useMetadocsWithAiResultsForFile";

type CopyMedicalRecordsFromMetadocButtonProps = MedicalHistoryTableProps & {
  hasExistingRecords: boolean;
};

const CopyMedicalRecordsFromMetadocButton = ({
  service,
  hasExistingRecords,
}: CopyMedicalRecordsFromMetadocButtonProps) => {
  const [showModal, setShowModal] = useState(false);
  const serviceType = getCopyMedicalRecordsServiceType(service);
  const { metadocsWithAiResults, hasMetadocsWithAiResults, isLoading } =
    useMetadocsWithAiResultsForFile(service.file?.id);

  if (!serviceType || isLoading || !hasMetadocsWithAiResults) {
    return null;
  }

  return (
    <>
      <Tooltip content="Import From Metadoc">
        <ButtonIcon
          kind="neutral"
          size="small"
          onClick={() => setShowModal(true)}
          aria-label="Import From Metadoc"
        >
          auto_awesome
        </ButtonIcon>
      </Tooltip>

      <CopyMedicalRecordsFromMetadocModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        service={service}
        metadocs={metadocsWithAiResults}
        hasExistingRecords={hasExistingRecords}
      />
    </>
  );
};

export default CopyMedicalRecordsFromMetadocButton;
